import React, { useState } from 'react';
import YearBlock from './YearBlock/YearBlock';
import css from './HeaderYear.module.scss';
import classnames from 'classnames';
import { svgSprite } from '../../../../../../../../../hybrid/wrappers';

const HeaderYear = ({ activeYear, yearSetter, years }) => {
    const [openYear, setOpenYear] = useState(false);
    return (
        <>
            <div className={css.dpHeader__year}>
                <p
                    className={classnames(css.dpHeader__date, css.dpHeader__date_click)}
                    onClick={() => setOpenYear((pre) => !pre)}
                >
                    {activeYear}
                </p>
                <button
                    type='button'
                    onClick={() => setOpenYear((pre) => !pre)}
                    className={classnames(css.dpHeader__yearSwith, openYear ? css.dpHeader__yearSwith_open : '')}
                >
                    {svgSprite('angle-down')}
                </button>
            </div>
            {!!openYear && <YearBlock years={years} yearSetter={yearSetter} activeYear={activeYear} setOpenYear={setOpenYear} />}
        </>
    );
};
export default HeaderYear;
